import { render, staticRenderFns } from "./sangria.vue?vue&type=template&id=6c570bb3"
import script from "./sangria.ts?vue&type=script&lang=js&external"
export * from "./sangria.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c570bb3')) {
      api.createRecord('6c570bb3', component.options)
    } else {
      api.reload('6c570bb3', component.options)
    }
    module.hot.accept("./sangria.vue?vue&type=template&id=6c570bb3", function () {
      api.rerender('6c570bb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/sessaoCaixa/sangria.vue"
export default component.exports